// showAlert.js
import Swal from 'sweetalert2';

const ShowSwalWithButtons = (title, text, icon, darkMode, onConfirm) => {
    Swal.fire({
        title: title,
        html: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#4CAF50",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
        customClass: {
            title: darkMode ? "swal-title-dark" : "swal-title-light",
            popup: darkMode ? "darkPopup" : "whitePopup",
        }
    }).then((result) => {
        if (result.isConfirmed && onConfirm) {
            onConfirm();
        }
    });
};

export default ShowSwalWithButtons;
